/* P0 Financial-Plausibility — web mirror of the backend contract
 * (services/market/yield_plausibility.py). Same 0–15 % fence so no
 * surface invents its own bound. Defense-in-depth: the backend already
 * nulls + flags poisoned yields, but every client fences again. */

export const YIELD_MIN_PCT = 0;
export const YIELD_MAX_PCT = 15;

// A concrete, finite, in-range yield (percent) that is safe to display.
export function isPlausibleYield(v) {
  if (v == null) return false;
  if (typeof v !== "number" || !Number.isFinite(v)) return false;
  return v >= YIELD_MIN_PCT && v <= YIELD_MAX_PCT;
}

// Return the value if plausible, else null (NEVER caps).
export function sanitizeYieldScalar(v) {
  return isPlausibleYield(v) ? v : null;
}

// Is the stored rent_estimate yield triple safe to display?
export function rentEstimateYieldPlausible(re) {
  if (!re) return false;
  for (const v of [re.gross_yield_avg, re.gross_yield_low, re.gross_yield_high]) {
    if (v == null) continue;
    if (!isPlausibleYield(v)) return false;
  }
  return true;
}

// The backend nulls poisoned yields and sets these flags — honour them so
// the client shows the honest "keine belastbare Renditeschätzung" notice
// even when the number itself is already null.
export function yieldSuspectFromBackend(re) {
  return !!(re && (re.yield_suspect === true || re.yield_recompute_required === true));
}
